import { LoaderCircle } from "lucide-react";
import type { ButtonHTMLAttributes, ReactNode } from "react";

interface LoadingButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  loadingLabel?: string;
  children: ReactNode;
}

export function LoadingButton({
  loading = false,
  loadingLabel = "Working…",
  disabled,
  children,
  ...props
}: LoadingButtonProps) {
  return (
    <button {...props} disabled={disabled || loading} aria-busy={loading || undefined}>
      {loading ? (
        <>
          <LoaderCircle className="spin" aria-hidden="true" />
          <span>{loadingLabel}</span>
        </>
      ) : (
        children
      )}
    </button>
  );
}
